import { useEffect } from 'react';
import { useSite } from '../../context/SiteContext';

const DocumentHead = () => {
  const { siteName, tagline } = useSite();

  useEffect(() => {
    const title = `${siteName} - Shop Fashion, Home, Beauty & More`;
    document.title = title;

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', `${siteName} - ${tagline}. Shop the latest fashion, home, beauty & more.`);
    }
  }, [siteName, tagline]);

  return null;
};

export default DocumentHead;
